// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { getItem } from '@/items/api/get-item';
import { ItemAccountingForm } from '@/items/components/item-accounting-form';
import { Alert, AlertTitle } from '@mui/material';
import { useSuspenseQuery } from '@tanstack/react-query';
import { Navigate, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/catalog/items/$itemKey/accounting')(
  {
    component: ItemAccountingRoute,
  }
);

function ItemAccountingRoute() {
  const { itemKey } = Route.useParams();

  const { data } = useSuspenseQuery({
    queryKey: ['item', itemKey],
    queryFn: () => getItem(itemKey),
  });

  // Only DEVICE items (hasAssets=true) have accounting
  // SERVICE and BULK items redirect to their appropriate default tabs
  if (!data.item.hasAssets) {
    if (data.item.isPhysical) {
      // BULK - redirect to units
      return (
        <Navigate
          to="/catalog/items/$itemKey/units"
          params={{ itemKey }}
          replace
        />
      );
    }
    // SERVICE - redirect to audit
    return (
      <Navigate
        to="/catalog/items/$itemKey/audit"
        params={{ itemKey }}
        replace
      />
    );
  }

  return (
    <ItemAccountingForm
      item={data.item}
      infoBanner={
        <Alert severity="info" sx={{ margin: 2 }}>
          <AlertTitle>Item accounting defaults</AlertTitle>
          These values will be inherited by each new asset created as a{' '}
          <strong>{data.item.name}</strong> item. Individual assets can override
          these defaults with their own accounting values.
        </Alert>
      }
      sx={{ paddingX: 2, paddingTop: 3, paddingBottom: 2 }}
    />
  );
}
